module.exports = __webpack_public_path__ + "static/5-sandy-259c0803d15feee6307b4b3b7bc71a86.jpg";